export default "__VITE_ASSET__01ae3e08__"